module.exports = __webpack_public_path__ + "img/star3.2d6be3fb.png";